export default {
    i18n: {
        "Group": "Gruppe",
        "auto": "Automatisk",
        "Device Name": "Enhedsnavn",
        "bluetooth": "Bluetooth",
        "Volume": "Lydstyrke",
        "Http": "HTTP",
        "day": "dag",
        "Device Information": "Enhedsoplysninger",
        "handset": "Telefonrør",
        "tamperAlarm": "Sabotagealarm",
        "Card": "Kort",
        "Fingerprint": "Fingeraftryk",
        "Date Time": "Dato og tid",
        "name": "Navn",
        "minutes": "minutter",
        "timezone": "Tidszone",
        "Are you sure you want to delete this device?": "Er du sikker på, at du vil slette denne enhed?",
        "Attendance Point Name": "Fremmødepunktsnavn",
        "Mac": "Mac",
        "confirmToDeleteIt?": "Bekræft for at slette?",
        "captureLogs": "Opfangede Logfiler",
        "Doors": "Døre",
        "All Doors": "Alle døre",
        "Lock List": "Låseliste",
        "Link Device Relay": "Forbundet enheds relæ",
        "Added Successfully!": "Tilføjet med succes!",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "Når låsen er forbundet med et relæ, låses låsen op, når relæ udløses.",
        "Adding...": "Tilføjer ...",
        "Please try again 24 hours later.": "Prøv igen om 24 timer.",
        "Action": "Handling",
        "unlock": "Lås op",
        "Address": "Adresse",
        "Owner": "Ejer",
        "Failed": "Mislykkedes",
        "Timeout": "Timeout",
        "Response": "Respons",
        "caller": "Besøgende",
        "receiver": "Modtager",
        "doorLogs": "Dør Log",
        "callHistory": "Opkaldshistorik",
        "UID": "UID",
        "Call Type": "Opkaldstype",
        "Code": "Kode",
        "User": "Bruger",
        "Device List": "Enhedsliste",
        "Model": "Model",
        "Time": "Tid",
        "Company": "Firma",
        "Property Managers": "Ejendomsansvarlige",
        "Current Version": "Nuværende version",
        "indoorMonitor": " Indendørs monitor ",
        "guardPhone": "Vagttelefon",
        "close": "Luk",
        "Success": "Succes",
        "URL": "URL",
        "Please select a device.": "Vælg venligst en enhed",
        "Password is too weak.": "Adgangskoden er for svag.",
        "Company is required.": "Firma er påkrævet.",
        "Your account is not activated, please contact your service provider.": "Din konto er ikke aktiveret. Kontakt venligst din tjenesteudbyder.",
        "Language": "Sprog",
        "Face": "Ansigt",
        "Please set at least one access type.": "Indstil mindst en adgangstype.",
        "Please contact your service provider to activate this advanced feature.": "Kontakt din tjenesteudbyder for at aktivere denne avancerede funktion.",
        "Community name": "Gruppenavn",
        "Please enable PM App first.": "Aktivér PM appen først.",
        "Username": "Brugernavn",
        "Change Log": "Ændrings log",
        "Assign": "Tildel",
        "Floor": "Etage",
        "Link Device": "Link enhed",
        "Accessible Floors": "Tilgængelige etager",
        "Upgrade": "Opgrader",
        "Function": "Funktion",
        "callDuration": "Opkalds Varighed",
        "No": "Ingen",
        "Verification Code": "Bekræftelseskode",
        "Expiration Time": "Udløbstidspunkt",
        "PIN": "PIN",
        "MAC": "MAC",
        "Building": "Bygning",
        "APT": "APT",
        "ID": "ID",
        "Name": "Navn",
        "activities": "Aktiviteter",
        "Obtain": "Modtag",
        "call": "Opkald",
        "Group Call": "Gruppeopkald",
        "Delete": "Slet",
        "Yes": "Ja",
        "Door Release PIN": "PIN-Kode til åbning",
        "Email": "E-mail",
        "Mobile Number doesn\'t exist.": "Mobil nummer eksistere ikke",
        "Tips": "Tips",
        "Password": "Adgangskode",
        "The end time cannot be earlier than the start time.": "Sluttiden kan ikke være tidligere end starttiden.",
        "Back": "Tilbage",
        "File format error.": "Fil format fejl",
        "motionDetection": "Bevægelsesregistrering",
        "You are trying too often, please try again in 5 minutes": "Du har prøvet for mange gange. Prøv igen om 5 minutter",
        "User name too long.": "Brugernavnet er for langt.",
        "This MAC address is redirected on RPS.": "Denne MAC adresse omdirigeres på RPS.",
        "No Answer": "Intet svar",
        "failedToUnlock": "Kunne ikke låse op",
        "visitor": "Besøgende",
        "yesterday": "I går",
        "Too large data! Please first export the data before %s first,thanks.": "Mændgen af data er for høj. Eksporter venligst dataene inden %s først, tak.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "Tjek venligst, om der er nogen ubetalte ordrer, hvis ikke, kontakt venligst din tjenesteudbyder",
        "lock": "Luk døren",
        "open": "Åben",
        "The PersonalAccount is not active.": "Personalaccount er ikke aktiv.",
        "You cannot link an account that already link other accounts.": "Du kan ikke linke en konto, der allerede forbinder andre konti.",
        "You cannot link multiple property manager accounts under the same installer account.": "Du kan ikke linke flere Property Manager konti på den samme installationskonto.",
        "You cannot link to the currently logged in account.": "Du kan ikke linke til den aktuelt loggede konto.",
        "nfc": "NFC",
        "Delete Device": "Slet enhed",
        "date": "Dato",
        "Device deleted successfully": "Enheden er slettet",
        "Failed to delete device": "Kunne ikke slette enhed",
        "Are you sure you want to cancel?": "Er du sikker på, at du vil annullere?",
        "Unlimited": "Ubegrænset",
        "Battery Level": "Batteriniveau",
        "Password Incorrect.": "Forkert adgangskode.",
        "deliverySystemVerification": "Verifikation af leveringssystem",
        "None": "Ingen",
        "Upgrading...": "Opgraderer...",
        "amenityReservation": "Reservation af faciliteter",
        "idAccess": "ID adgang",
        "exitButton": "Udgangsknap",
        "Please select at least one item.": "Vælg venligst mindst én post.",
        "The ID can contain only digits and letters, up to 32 characters.": "ID\'et kan kun indeholde cifre og bogstaver, op til 32 tegn.",
        "The PIN is not available.": "PIN-koden er ikke tilgængelig.",
        "Change WiFi": "Skift WiFi",
        "Access Denied.": "Adgang nægtet.",
        "RF Card": "RF Kort",
        "Phone number": "Telefonnummer",
        "Invalid {0}.": "Ugyldig {0}.",
        "{0} already exists.": "{0} findes allerede.",
        "Operation failed!": "Operation mislykkedes!",
        "Failed to get data.": "Kunne ikke hente data.",
        "You do not have the necessary permissions to perform this operation.": "Du har ikke rettigheder til at udfører denne handling.",
        "You can only import one template at a time in the current site.": "Du kan kun importere én skabelon ad gangen på det aktuelle websted.",
        "Delivery name": "Leverings navn",
        "MAC address not in the MAC library.": "MAC-adressen er ikke i MAC-biblioteket.",
        "Please delete devices under this building.": "Venligst slet ender tilknyttet denne bygning",
        "The start time cannot be later than the end time.": "Starttiden må ikke være senere end sluttiden",
        "emergency action type": "Nødhandlingstype",
        "Only 1000 data items can be imported at a time.": "Kun 1000 data kan blive importeret af gangen",
        "The password is too short.": "Kodeordet er ikke langt nok.",
        "The data has been updated. Please refresh the page and try again.": "Dataen er blevet opdateret. Opdater venligst siden og prøv igen.",
        "AutoP length must be less 2048 bytes.": "AutoP længden skal være mindre end 2048 bytes.",
        "File Check Failed": "Filkontrol mislykkedes",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "Administratorens login er udløbet. Kontakt din tjenesteudbyder.",
        "iqPinVerificationFailed": "IQ PIN-verificering mislykkedes.",
        "accountBlacklisted": "Kontoen er sortlistet.",
        "outsideAuthorizedTime": "Uden for tilladt tidsrum.",
        "network group": "netværksgruppe",
        "Company name": "Firmanavn",
        "Group name": "Gruppenavn",
        "relay": "relæ",
        "motionTime": "Bevægelsesdetektionstid",
        "motionType": "Bevægelsesdetektionstype",
        "postalCode": "Postnummer",
        "floor format": "Etageformat",
        "mobilePhone": "Mobiltelefonnummer",
        "time format": "tidsformat",
        "security relay": "sikkerhedsrelæ",
        "Param": "Parameter",
        "Offline Code": "Offline kode",
        "Add akubela Smart Locks": "Tilføj akubela Smart Locks",
        "Module Version": "Modulversion",
        "Lock Body Version": "Låskrop version",
        "Available Version": "Tilgængelig version",
        "Please wake up the lock screen and then upgrade.": "Væk låseskærmen og opgrader derefter.",
        "This process will take some time, please be patient.": "Denne proces tager lidt tid, hav venligst tålmodighed.",
        "Please confirm that the WiFi network is functioning properly.": "Bekræft at WiFi-netværket fungerer korrekt.",
        "Please wake up the lock screen.": "Væk venligst låseskærmen.",
        "This lock has already been added to another apartment.": "Denne lås er allerede blevet tilføjet til en anden lejlighed.",
        "This lock has already been added to the apartment.": "Denne lås er allerede blevet tilføjet til lejligheden.",
        "Pin Code": "Pinkode",
        "Too many failed attempts, please try again in a few minutes.": "For mange mislykkede forsøg, prøv igen om et par minutter.",
        "Login Account": "Log ind-konto",
        "Same account cannot login in different ins.": "Den samme konto kan ikke logge ind på forskellige installatører.",
        "Lock Name": "Låsenavn",
        "Smart Locks": "Smartlåse",
        "Add Smart Lock": "Tilføj smartlås",
        "The selected duration cannot be more than one year.": "Den valgte varighed må ikke være længere end ét år.",
        "The end time of the break time cannot be later than the end work time.": "Sluttidspunktet for pausen må ikke være senere end arbejdstidens sluttidspunkt.",
        "The start time of the break time cannot be earlier than the start work time.": "Starttidspunktet for pausen må ikke være tidligere end starttidspunktet for arbejdet.",
        "The end time of the valid check time cannot be earlier than the end work time.": "Sluttidspunktet for den gyldige tjek-ind tid må ikke være tidligere end arbejdstidens sluttidspunkt.",
        "The start time of the valid check time cannot be later than the start work time.": "Starttidspunktet for den gyldige tjektid må ikke være senere end arbejdstidens starttidspunkt.",
        "Deleting failed. The timetable is used by a shift.": "Sletning mislykkedes. Tidsplanen bruges af et skift.",
        "Deleting failed. The shift is in use.": "Sletning mislykkedes. Vagten er i brug.",
        "Deleting failed. The leave type is in use.": "Sletning mislykkedes. Ferietypen er i brug.",
        "Valid time conflicts with an existing schedule.": "Gyldig tid er i konflikt med en eksisterende vagtplan.",
        "The timing for multiple schedules must not coincide.": "Tidspunkterne for flere tidsplaner må ikke falde sammen.",
        "Attendance Log": "Fremmødelog",
        "Added Failed!": "Tilføjelse mislykkedes!",
        "Setting WiFi": "Indstiller WiFi",
        "License Plate": "Nummerplade",
        "key": "Kode",
        "IQ Offline.": "IQ offline.",
        "{0}Unlock": "{0} Lås op",
        "automatically": "Automatisk",
        "manually": "Manuelt",
        "Video Storage": "Videoopbevaring",
        "Device(s) for Video Storage": "Enhed(er) til videoopbevaring",
        "The amount of exported data is too large. Please export it in batches.": "Mængden af eksporterede data er for stor. Eksportér venligst i partier",
        "Auto-record video when door unlocks": "Optag video automatisk når døren låses op",
        "Auto-record video during calls": "Optag video automatisk under opkald",
        "Manual video recording in monitoring": "Manuel videooptagelse under overvågning",
        "Saved for 30days/60days/90days": "Gemt i 30/60/90 dage",
        "To subscribe, please contact your provider for activation.": "Kontakt din udbyder for at aktivere abonnement.",
        "Saved for {0}days": "Gemt i {0} dage",
        "Subscribed Plan": "Abonnement",
        "Supported Devices: {0}": "Understøttede enheder: {0}",
        "{0}Lock": "{0} Lås",
        "Video Saving": "Videosave",
        "Download Completed!": "Download gennemført!",
        "Fail to download.": "Download mislykkedes.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "Sletning mislykkedes! Ejendomsadministratoren er blevet knyttet til en RentManager-kunde, du skal først slette denne tilknytning.",
        "No log to be exported.": "Ingen log at eksportere.",
        "capture&Video": "Skærmbillede & Video",
        "packageDetection": "Pakkedetektion",
        "Time format is invalid.": "Tidsformatet er ugyldigt.",
        "No permission to export logs of this type.": "Ingen tilladelse til at eksportere logfiler af denne type.",
        "Project type is invalid.": "Projekttypen er ugyldig.",
        "Salto Account Blocked.": "Salto-konto blokeret.",
        "Remote open not in access group.": "Fjernåbning ikke tilladt for denne adgangsgruppe.",
        "SIP Account required.": "SIP-konto er påkrævet.",
        "The PIN must be {0} digits.": "PIN-koden skal være på {0} cifre.",
        "gatewayConnectionUnavailable": "Gateway-forbindelse utilgængelig.",
        "Invalid Username or Password": "Ugyldigt brugernavn eller adgangskode",
        "Account already linked to another user.": "Kontoet er allerede knyttet til en anden bruger.",
        "The account has been added by another user.": "Kontoen er blevet tilføjet af en anden bruger.",
        "Failed to add. This user already has 5 license plates.": "Tilføjelse mislykkedes. Denne bruger har allerede 5 nummerplader.",
        "Please at least select a door.": "Vælg venligst mindst en dør.",
        "UHF Card": "UHF-kort",
        "personnel": "personale",
        "Parking Lot Name": "Parkeringspladsens navn",
        "Controlled Relay": "Kontrolleret relæ",
        "No Permission": "Ingen tilladelse",
        "Please ensure that all doors in the project are activated at the same time.": "Sørg venligst for, at alle døre i projektet aktiveres samtidig.",
        "gatewayBusy": "Gateway optaget",
        "Please set the perimeter door group first.": "Indstil perimeter-dørgruppen først.",
        "Please ensure that all doors in the project are renewed at the same time.": "Sørg venligst for, at alle døre i projektet fornyes på samme tid.",
        "When lockdown is on, the controlled relay cannot be modified.": "Når der er låst, kan den kontrollerede relæ ikke ændres.",
        "DetectionLogs": "Detektionslog",
        "packageIn": "Pakke indleveret",
        "packageOut": "Pakke hentet",
        "View Progress": "Se status",
        "Check if the WiFi is operating on the 2.4GHz band.": "Kontroller om WiFi\'en kører på 2,4GHz-båndet.",
        "Verify that the WiFi password is correct.": "Bekræft, at WiFi-adgangskoden er korrekt.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "Sørg for, at du er tilsluttet den rigtige enheds hotspot under hotspot-konfigurationen.",
        "Offline Code Unlock": "Lås op med offline kode",
        "Salto Token Expired.": "Salto-token er udløbet.",
        "Lock Offline": "Lås offline",
        "identity information! Please login again": "Identitetsoplysninger! Log venligst ind igen",
        "Email is required.": "Email er påkrævet.",
        "Mobile number is required.": "Mobilnummer er påkrævet.",
        "You can\'t make payments for offices in different time zones.": "Du kan ikke foretage betalinger for kontorer i forskellige tidszoner.",
        "The current scheduling staff exceeds 200 people.": "Det nuværende vagtplanlægningsteam overstiger 200 personer.",
        "param": "parameter",
        "Invalid UserName or Password": "Ugyldigt brugernavn eller adgangskode",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "Din Salto KS-konto har ikke tilladelse til at ændre låsens navn.",
        "Owner is required.": "Ejer er påkrævet.",
        "Office is required.": "Kontor er påkrævet.",
        "PIN or RF Card is required.": "PIN eller RF-kort er påkrævet.",
        "RF card": "RF-kort",
        "Personnel is required.": "Personale er påkrævet.",
        "email address": "e-mailadresse",
        "mobile number": "mobilnummer",
        "The length must be less than 32 characters.": "Længden skal være mindre end 32 tegn.",
        "The length must be less than 256 characters.": "Længden skal være mindre end 256 tegn.",
        "Access Group is required.": "Adgangsgruppe er påkrævet.",
        "Device is required.": "Enhed er påkrævet.",
        "Admin is required.": "Administrator kræves.",
        "Mobile number": "Mobilnummer",
        "schedules": "tidsplaner",
        "Timetable name": "Tidsplanens navn",
        "Shift name": "Skiftnavn",
        "Leave type": "Fraværstype",
        "recheck in time": "genindtjekningstid",
        "recheck out time": "genbekræft udtjekningstid",
        "The building name": "Bygningens navn",
        "Building is required.": "Bygning er påkrævet.",
        "selection, The same reader cannot be set for both entry and exit": "Valg, Den samme læser kan ikke indstilles til både indgang og udgang",
        "Door number": "Dørnummer",
        "door input cannot be selection duplicated.": "Dørinput kan ikke vælges flere gange.",
        "Group is required.": "Gruppe er påkrævet.",
        "Title can contain up to 32 characters.": "Titlen kan indeholde op til 32 tegn.",
        "Content can contain up to 1024 characters.": "Indhold kan indeholde op til 1024 tegn.",
        "Content can contain up to 64 characters.": "Indhold kan indeholde op til 64 tegn.",
        "Report is required.": "Rapport er påkrævet.",
        "ID is required.": "ID er påkrævet.",
        "The office does not exist.": "Kontoret eksisterer ikke.",
        "Office name": "Kontornavn",
        "The Temp Key does not exist.": "Temp-nøglen findes ikke.",
        "autolock time": "autolåsetid",
        "The User does not exist.": "Brugeren findes ikke.",
        "The Installer does not exist.": "Installatøren findes ikke.",
        "The Project does not exist.": "Projektet eksisterer ikke.",
        "The Distributor does not exist.": "Distributøren findes ikke.",
        "The Community Device does not exist.": "Fællesskabsenheden findes ikke.",
        "The Property Manager does not exist.": "Ejendomsadministratoren eksisterer ikke.",
        "The Sub Distributor does not exist.": "Underdistributøren findes ikke.",
        "The Single Slave does not exist.": "Den enkelte lejer findes ikke.",
        "The Property Manager EndUser does not exist.": "Ejendomsadministratorens slutbruger findes ikke.",
        "The Family Member does not exist.": "Familiemedlemmet findes ikke.",
        "Set Failed!": "Indstilling mislykkedes!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "Du har nået grænsen på 10 adgangskodeanmodninger inden for en periode på 30 minutter. Prøv venligst igen senere.",
        "This Email doesn\'t exist.": "Denne e-mail findes ikke.",
        "detection type": "detektionstype",
        "Device UUID": "Enheds-UUID",
        "smart lock device": "smart låseenhed",
        "You are trying too often, please try again in 5 minutes.": "Du forsøger for ofte, prøv igen om 5 minutter.",
        "You can only import one file at a time. Please wait for the current import to finish.": "Du kan kun importere én fil ad gangen. Vent venligst, indtil den nuværende import er færdig.",
        "NVR Name": "NVR-navn",
        "NVR Address": "NVR-adresse",
        "Stay Alarm": "Opholdsalarm",
        "Happended On": "Skete den",
        "Edit Milesight NVR": "Rediger Milesight NVR",
        "Add Milesight NVR": "Tilføj Milesight NVR",
        "Auto-record video on motion detection, package detection": "Optag video automatisk ved bevægelse eller pakkedetektion",
        "A 7-day free trial is included with your subscription.": "Dit abonnement indeholder 7 dages gratis prøveperiode.",
        "For service renewal, please reach out to your provider.": "Kontakt din udbyder for fornyelse af tjenesten.",
        "Allow the Property Manager to view recorded videos": "Giv ejendomsadministratoren adgang til at se optagede videoer",
        "Please ensure the WiFi network is working properly.": "Sørg for, at WiFi-netværket fungerer korrekt.",
        "Edit akubela Smart Locks": "Rediger akubela Smart Locks",
        "Upgraded Successfully!": "Opgraderet med succes!",
        "Upgraded Failed!": "Opgradering mislykkedes!",
        "Editing...": "Redigerer...",
        "Edited successfully!": "Redigeret med succes!",
        "Edited Failed!": "Redigering mislykkedes!",
        "Downloading video...": "Downloader video...",
        "All Locks": "Alle låse",
        "Select Locks": "Vælg låse",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "Den {0}-cifrede PIN-kode kan bruges, når akubela smartlåsen er forbundet til netværket. Bemærk, at det kan tage lidt tid, før PIN-koden træder i kraft efter synkronisering.",
        "Please at least select a door or a lock.": "Vælg venligst mindst en dør eller en lås.",
        "This lock has already been added to your apartment.": "Denne lås er allerede tilføjet til din lejlighed.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "Denne lås er allerede tilføjet til en anden lejlighed. Kontakt venligst din tjenesteudbyder for hjælp.",
        "LockBody Version": "Låskrop version",
        "Two-factor Authentication": "To-faktor-godkendelse",
        "Monitoring Scope": "Overvågningsområde",
        "Stay Duration": "Opholdstid",
        "Volume Settings": "Lydstyrkeindstillinger",
        "get card list for lock error": "Fejl ved hentning af kortliste til lås",
        "get card list parse fail": "Kunne ikke fortolke kortlisten",
        "get pin list for lock error": "Fejl ved hentning af PIN-liste til lås",
        "get pin list parse fail": "Kunne ikke fortolke PIN-listen",
        "fingerprint code must be less than 2048 characters or empty.": "Fingeraftrykskode skal være under 2048 tegn eller tom.",
        "Personnel not in office.": "Personale er ikke på kontoret.",
        "customize form fail.": "Tilpasning af formular mislykkedes.",
        "smart lock type error.": "Fejl i typen af smartlås.",
        "invalid client id or secret": "Ugyldigt klient-ID eller hemmelighed",
        "invalid account or password": "Ugyldig konto eller adgangskode",
        "invalid access token": "Ugyldig adgangstoken",
        "invalid refresh token": "Ugyldig opdateringstoken",
        "no permission to access this project": "Ingen tilladelse til at tilgå dette projekt",
        "Stay Alarm Time": "Alarmtid",
        "This function only support sl20 lock.": "Denne funktion understøtter kun sl20-låsen.",
        "Json marshal error.": "JSON-marshalling fejl.",
        "Json unmarshal error.": "JSON-unmarshalling fejl.",
        "Illegal request, not added within valid time.": "Ugyldig anmodning, ikke tilføjet inden for gyldig tid.",
        "invalid nvr type": "Ugyldig NVR-type",
        "project is empty": "Projektet er tomt",
        "project type is invalid": "Projektets type er ugyldig",
        "owner is invalid": "Ejer er ugyldig",
        "url is invalid": "URL er ugyldig",
        "password is invalid": "Adgangskode er ugyldig",
        "building is invalid": "Bygning er ugyldig",
        "fail to get data": "Kunne ikke hente data",
        "invalid allow pm view type": "Ugyldig PM-vistype tilladt",
        "Data not exist.": "Data eksisterer ikke.",
        "cannot find community PrivateKey.": "Kan ikke finde community PrivateKey.",
        "cannot find single PrivateKey.": "Kan ikke finde enkelt PrivateKey.",
        "The third party not exist.": "Tredjepart eksisterer ikke.",
        "{0} and indoor monitors/guard phones": "{0} og indendørs skærme/vagttelefon",
        "{0} and indoor monitors/guard phones, with phone as backup": "{0} og indendørs skærme/vagttelefon, med telefon som backup",
        "Indoor monitors/guard phones with {0} as backup": "Indendørs skærme/vagttelefon med {0} som backup",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "Indendørs skærme/vagttelefon med {0} som backup, til sidst telefonen",
        "{0} Intercom Feature": "{0} intercom-funktion",
        "Capture on {0}": "Tag skærmbillede i {0}",
        "{0} Intercom Feature is not activated or has expired.": "{0} intercom-funktionen er ikke aktiveret eller er udløbet.",
        "fingerprint code must be equal 1620 characters or empty.": "Fingeraftrykskode skal være nøjagtig 1620 tegn eller tom.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "For at sikre en vellykket opgradering skal du sikre, at låsens batteriniveau er over 40%, før du fortsætter.",
        "Automatic Locking Time": "Automatisk låsetid",
        "WiFi Keep-Alive": "WiFi vedligeholdelse",
        "WiFi Setting": "WiFi indstilling",
        "Connecting the network...": "Opretter forbindelse til netværket...",
        "Set successfully!": "Indstillet med succes!",
        "The offline code can be used even if the lock is not connected to WiFi.": "Offlinekoden kan bruges, selv om låsen ikke er tilsluttet WiFi.",
        "Enabling this feature will increase the lock\'s power consumption.": "Aktivering af denne funktion vil øge låsens strømforbrug.",
        "Each offline code can only be used once.": "Hver offline kode kan kun bruges én gang.",
        "Receiver Info": "Modtagerinformation",
        "log id": "Log-id",
        "Create HW SN Config Empty SN.": "Opret HW SN-konfiguration tom SN.",
        "The SN": "Serienummeret",
        "SN can contain up to 32 characters.": "SN kan indeholde op til 32 tegn.",
        "Check HW SN Not Found.": "Tjek HW SN ikke fundet.",
        "the end user not found": "Slutbruger ikke fundet",
        "Family Call": "Familieopkald",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "Under opgraderingen vil alle låserelaterede funktioner midlertidigt være utilgængelige.",
        "8-digit PIN code starting with \"9\" is invalid!": "8-cifret PIN-kode der starter med \"9\" er ugyldig!",
        "Lock name length must be between 1 and 50": "Låsenavnet skal være mellem 1 og 50 tegn",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "Antallet af personale med fastnettelefontjeneste må ikke overstige antallet af dem med {0} interkom.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "Antallet af administratorer med fastnettelefontjeneste må ikke overstige antallet af dem med {0} interkom.",
        "charge type": "betalingstype",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "Antallet af medarbejdere med fastnettelefontjeneste må ikke overstige antallet af dem med SmartPlus Intercom.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "Antallet af administratorer med fastnettelefontjeneste må ikke overstige antallet af dem med SmartPlus Intercom.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "En læser kan ikke konfigureres til at bruge både Wiegand og RS485 samtidigt.",
        "parameter error": "Parameterfejl",
        "community name already exist": "Fællesskabsnavnet findes allerede",
        "personnel app without intercom feature number": "Personaleapp uden intercom-funktionsnummer",
        "check feature billing charge plan new error": "Fejl ved kontrol af funktions-betalingsplan",
        "subscription not found": "Abonnement ikke fundet",
        "System setting record not found.": "Systemindstillingspost ikke fundet.",
        "Smart home not enabled.": "Smart home er ikke aktiveret.",
        "the apt call type value is invalid.": "Værdien for apt-opkaldstype er ugyldig.",
        "the ip call or sip call value is invalid.": "Værdien for IP-opkald eller SIP-opkald er ugyldig.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode skal være et 2-8-cifret tal, men kan ikke være et 8-cifret tal der starter med 9 eller være tomt.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard skal være A-F0-9 og mindre end 16 cifre eller tomt.",
        "owner cannot be empty.": "Ejer kan ikke være tom.",
        "creator cannot be empty.": "Opretter kan ikke være tom.",
        "the creator type value is invalid": "Oprettertypens værdi er ugyldig",
        "the IsCreateByPm value is invalid": "IsCreateByPm-værdien er ugyldig",
        "the pinCode already exist": "pinCode findes allerede",
        "the rfCard already exist": "rfCard findes allerede",
        "license plate is invalid.": "Nummerplade er ugyldig.",
        "owner info is invalid.": "Ejerinformation er ugyldig.",
        "uhf is invalid.": "uhf er ugyldig.",
        "time control is invalid.": "Tidskontrol er ugyldig.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "Du har nået grænsen på 5 nummerplader og kan ikke tilføje flere",
        "the plate already exist": "Nummerpladen findes allerede",
        "the uhf already exist": "uhf findes allerede",
        "empty community": "Tomt fællesskab",
        "no find license Plate": "Nummerplade ikke fundet",
        "IDAccess mode must be 0, 1, or 2.": "IDAccess-tilstand skal være 0, 1 eller 2.",
        "Run field is required when mode is 1 or 2.": "Run-feltet er påkrævet, når tilstanden er 1 eller 2.",
        "Serial field is required when mode is 2.": "Serial-feltet er påkrævet, når tilstanden er 2.",
        "the pin cannot be empty": "pin kan ikke være tom",
        "the rfCard cannot be empty": "rfCard kan ikke være tom",
        "the IDAccess already exist": "IDAccess findes allerede",
        "the resident cannot be empty": "Beboer kan ikke være tom",
        "the fingerprint cannot be empty": "Fingeraftryk kan ikke være tomt",
        "the face cannot be empty": "Ansigt kan ikke være tomt",
        "not found pin": "pin blev ikke fundet",
        "not found rfCard": "rfCard blev ikke fundet",
        "not found IDAccess": "IDAccess blev ikke fundet",
        "not found fingerprint": "Fingeraftryk blev ikke fundet",
        "not found face": "Ansigt ikke fundet",
        "face pic is invalid.": "Ansigtsbillede er ugyldigt.",
        "community build and room cannot be empty.": "Fællesskab og rum kan ikke være tomt.",
        "device info mac cannot be empty.": "Enhedsinfo mac kan ikke være tom.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "Planlægningstype skal være 0, 1, 2, eller tidsformat er ugyldigt, eller dataflag ikke mellem 0-127.",
        "MAC address cannot be empty.": "MAC-adressen kan ikke være tom.",
        "MAC address 0C1105000000 is not allowed.": "MAC-adressen 0C1105000000 er ikke tilladt.",
        "MAC address must be 12 hexadecimal characters.": "MAC-adressen skal være 12 hexadecimale tegn.",
        "Scheduler type value is invalid.": "Planlægningstypeværdi er ugyldig.",
        "parse is fail": "Fortolkning mislykkedes",
        "the fingerprint already exist": "Fingeraftryk findes allerede",
        "the licensePlate cannot be empty": "Nummerplade kan ikke være tom",
        "the licensePlate already exist": "Nummerpladen findes allerede",
        "idaccess run must be 10 digit number or end with -K.": "idaccess-run skal være et 10-cifret tal eller slutte med -K.",
        "idaccess serial must be 9 digit number.": "idaccess-serienummer skal være 9 cifre.",
        "relay not in 0-15": "Relæ ikke i 0-15",
        "security relay not in 0-3": "Sikkerhedsrelæ ikke i 0-3",
        "file name is wrong": "Filnavn er forkert",
        "access mode specified": "Adgangstilstand specificeret",
        "create community user accessmode failed.": "Oprettelse af fællesskabsbrugeradgangstilstand mislykkedes.",
        "delete community user accessmode failed.": "Sletning af fællesskabsbrugeradgangstilstand mislykkedes.",
        "Cannot delete building because it has associated users.": "Kan ikke slette bygningen, fordi den har tilknyttede brugere.",
        "Cannot delete building because it has associated Salto devices.": "Kan ikke slette bygningen, fordi den har tilknyttede Salto-enheder.",
        "community building not found": "Fællesskabsbygning ikke fundet",
        "Invalid Name Display": "Ugyldigt navnevisning",
        "The Community does not exist.": "Fællesskabet findes ikke.",
        "Update CommunityIsInstallerKit Error.": "Fejl ved opdatering af CommunityIsInstallerKit.",
        "Dis Not SupportCommunityCalls Error.": "Agent understøtter ikke fællesskabsopkald-fejl.",
        "Community Has Special Device, Not Allowed To Delete.": "Fællesskabet har særligt udstyr, må ikke slettes.",
        "The project smart home switch must be disabled": "Projektets smart home-knap skal være deaktiveret",
        "There are ITec Locks in project": "Der er ITec-låse i projektet",
        "There are Salto Locks in project": "Der er Salto-låse i projektet",
        "There are Dormakaba Locks in project": "Der er Dormakaba-låse i projektet",
        "It is rent manager project": "Det er et rent manager-projekt",
        "It is installer account": "Det er en installatørkonto",
        "contact preference type": "Kontaktpræference-type",
        "Floor list is required when not all floors.": "Etageliste er påkrævet, når det ikke er alle etager.",
        "Building floors list is required when all buildings.": "Bygningers etageliste er påkrævet, når det er alle bygninger.",
        "Indoor monitor name is required.": "Navn på indendørs monitor er påkrævet.",
        "The primary account is not activated.": "Hovedkontoen er ikke aktiveret.",
        "You can\'t create more family member accounts.": "Du kan ikke oprette flere familiemedlemskonti.",
        "community user not found": "Fællesskabsbruger ikke fundet",
        "community is empty": "Fællesskab er tomt",
        "the end user not master user": "Slutbruger er ikke hovedbruger",
        "the end user not member user": "Slutbruger er ikke medlemsbruger",
        "The email already exists and cannot be repeated": "E-mailen findes allerede og kan ikke gentages",
        "The mobile Number already exists": "Mobilnummer findes allerede",
        "The room number format error.": "Fejl i værelsesnummerformat.",
        "community not found": "Fællesskab ikke fundet",
        "resident not found": "Beboer ikke fundet",
        "installer not found": "Installatør ikke fundet",
        "Operation Failed!": "Operation mislykkedes!",
        "You don\'t have operate permission": "Du har ikke tilladelse til at udføre handlingen",
        "You cannot select Relay and Door at the same time": "Du kan ikke vælge relæ og dør på samme tid",
        "user don\'t active": "Bruger er ikke aktiv",
        "User has expired": "Bruger er udløbet",
        "timestamp must be within 3 minutes of current server time": "Tidsstemplet skal være inden for 3 minutter af aktuel servertid",
        "cannot find single rf Card.": "Kan ikke finde enkelt rfCard.",
        "cannot find community rf Card.": "Kan ikke finde fællesskabs-rfCard.",
        "smartLock model": "SmartLock-model",
        "the project does not open smart home": "Projektet åbner ikke smart home",
        "php web server error": "php webserverfejl",
        "Ins not found.": "Ins ikke fundet.",
        "RentManage Unit Not Set.": "RentManage-enhed ikke indstillet.",
        "add audit log error": "Fejl ved tilføjelse af revisionslog",
        "check building in error": "Fejl ved tjek af bygning",
        "Special devices cannot be deleted": "Specielle enheder kan ikke slettes",
        "the email is empty": "E-mail er tom",
        "the email format is incorrect": "E-mailformatet er forkert",
        "the mobile number is empty": "Mobilnummer er tomt",
        "the mobile number format is incorrect": "Mobilnummerformatet er forkert",
        "Site not found": "Projekt ikke fundet",
        "User not found": "Bruger ikke fundet",
        "invalid time format": "Ugyldigt tidsformat",
        "ground floor type": "Mellemetage-format",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "Startetageinterval fejl, gyldige værdier er -10 til -1, G0, G1, G2, 1 til 128.",
        "Building ID must be between 1 and 99.": "Bygnings-ID skal være mellem 1 og 99.",
        "Community building name": "Fællesskabsbygningsnavn",
        "Building ID already exists in this community.": "Bygnings-ID findes allerede i dette fællesskab.",
        "building ID": "Bygnings-ID",
        "Community building not found.": "Fællesskabsbygning ikke fundet.",
        "Cannot delete building because it has associated devices.": "Kan ikke slette bygning, fordi der er tilknyttede enheder.",
        "project is not valid": "Projektet er ikke gyldigt",
        "Cannot delete building because it has associated salto devices.": "Kan ikke slette bygning, fordi der er tilknyttede salto-enheder.",
        "Cannot delete building because it has associated iTec devices.": "Kan ikke slette bygning, fordi der er tilknyttede iTec-enheder.",
        "Cannot delete building because it has associated dormakaba devices.": "Kan ikke slette bygning, fordi der er tilknyttede dormakaba-enheder.",
        "member limit num": "Medlemsgrænseantal",
        "Indoor Monitor No Set Error.": "Indendørs monitor ikke indstillet fejl.",
        "The room not has indoor": "Rummet har ingen indendørs enhed.",
        "check user in building error": "tjek bruger i bygningsfejl",
        "The name specified is already in use.": "Det angivne navn er allerede i brug.",
        "This timeblock overlaps with an existing one. Please adjust it.": "Denne tidsblok overlapper med en eksisterende. Juster venligst.",
        "This door status changed. Please try again.": "Dørens status er ændret. Prøv venligst igen.",
        "the lock can\'t bind this community": "Låsen kan ikke binde dette fællesskab",
        "The custom quantity limit has been exceeded!": "Den brugerdefinerede mængdegrænse er overskredet!",
        "This time span overlaps with an existing one. Please adjust it.": "Denne tidsperiode overlapper med en eksisterende. Juster venligst.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "Denne engangskørsel overlapper med den eksisterende engangskørsels gyldige tidsrum. Juster venligst.",
        "Operation Failed. Please try again.": "Operation mislykkedes. Prøv igen.",
        "The image is not a front view.": "Billedet er ikke et frontalt billede.",
        "A mask was detected.": "En maske blev registreret.",
        "The image resolution is too low.": "Billedets opløsning er for lav.",
        "No face was detected.": "Ingen ansigt blev registreret.",
        "The file size is too large.": "Filstørrelsen er for stor.",
        "The face in the image is too large.": "Ansigtet på billedet er for stort.",
        "The face in the image is too small.": "Ansigtet på billedet er for lille.",
        "Multiple faces detected.": "Flere ansigter registreret.",
        "The face is not clear enough.": "Ansigtet er ikke tydeligt nok.",
        "Face detection failed.": "Ansigtsgenkendelse mislykkedes.",
        "Please enter a value between 1 and 9999": "Indtast venligst en værdi mellem 1 og 9999",
        "Please select which input your door sensor is connected to.": "Vælg venligst, hvilken indgang din dørsensor er tilsluttet til.",
        "Add temp key failed, please try it again": "Tilføjelse af midlertidig nøgle mislykkedes, prøv venligst igen",
        "Dis Not Support Dynamic QRCode Error.": "Understøtter ikke dynamisk QR-kodefejl.",
        "QR code not exist": "QR-kode eksisterer ikke",
        "The temp key has expired.": "Den midlertidige nøgle er udløbet.",
        "The device is not in the office": "Enheden er ikke på kontoret",
        "The device is already assigned.": "Enheden er allerede tildelt.",
        "The device cannot be assigned to any user.": "Enheden kan ikke tildeles nogen bruger.",
        "You cannot select an option with fewer users than the current project members.": "Du kan ikke vælge en mulighed med færre brugere end de nuværende projektmedlemmer.",
        "File check failed. Please download the latest template and try again.": "Filkontrol mislykkedes. Download venligst den nyeste skabelon og prøv igen.",
        "Dynamic QR Code not active.": "Dynamisk QR-kode ikke aktiv.",
        "Dynamic QR Code not enable.": "Dynamisk QR-kode ikke aktiveret.",
        "{0} not found.": "{0} ikke fundet.",
        "Tier charge plan": "Trinvis takstplan",
        "Feature billing charge plan new": "Funktion faktureringsplan ny",
        "Feature billing gradient charge plan": "Funktion fakturering gradient gebyrplan",
        "The exit time cannot be earlier than the entry time.": "Udgangstidspunktet kan ikke være tidligere end indgangstidspunktet.",
        "User Name or Password": "Brugernavn eller adgangskode",
        "You can only link up to 5 sites.": "Du kan kun tilknytte op til 5 steder.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "Denne nummerplade er allerede registreret til en beboer og kan ikke tilføjes til blokeringslisten.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "Denne nummerplade er sortlistet og kan ikke registreres som et køretøj.",
        "Elevator not configured in company access floor.": "Elevatoren er ikke konfigureret til virksomhedens adgangsetager.",
        "the device is not in the office": "enheden er ikke på kontoret",
        "A maximum of 1000 data items can be imported": "Der kan maksimalt importeres 1000 dataposter",
        "Exit time cannot be later than the current time.": "Udgangstidspunktet må ikke være senere end det aktuelle tidspunkt.",
        "You can only import a file at a time in the current parking lot.": "I den aktuelle parkeringsplads kan du kun importere én fil ad gangen.",
        "The license plate is already in the blocklist.": "Nummerpladen er allerede på blokeringslisten.",
        "Building name too long.": "Bygningsnavnet er for langt.",
        "Unlock failed. Permission denied by user.": "Oplåsning mislykkedes. Tilladelse blev afvist af brugeren.",
        "Please remove the sensor device(s) before disabling this feature.": "Fjern venligst sensorenheden/-enhederne, før du deaktiverer denne funktion.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "Handlingen mislykkedes! Den daglige grænse på 15 poster er overskredet for denne bruger.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "Der kan tilføjes op til {0} offentlige enheder pr. projekt. Kontakt Akuvox Technical Support på support{'@'}akuvox.com for at tilføje flere.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "Der kan tilføjes op til {0} personalekonti pr. projekt. Kontakt Akuvox Technical Support på support{'@'}akuvox.com for at tilføje flere.",
        "cancel": "Fortryd",


    }
};
